import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export default {
  name: 'TransitionExpand',
  functional: true,
  render: function render(createElement, context) {
    /* eslint-disable no-param-reassign */
    var data = {
      props: {
        name: 'expand'
      },
      on: {
        afterEnter: function afterEnter(element) {
          element.style.height = 'auto';
        },
        enter: function enter(element) {
          var _getComputedStyle = getComputedStyle(element),
              width = _getComputedStyle.width;

          element.style.width = width;
          element.style.position = 'absolute';
          element.style.visibility = 'hidden';
          element.style.height = 'auto';

          var _getComputedStyle2 = getComputedStyle(element),
              height = _getComputedStyle2.height;

          element.style.width = null;
          element.style.position = null;
          element.style.visibility = null;
          element.style.height = 0; // eslint-disable-next-line no-unused-expressions

          getComputedStyle(element).height;
          setTimeout(function () {
            element.style.height = height;
          });
        },
        leave: function leave(element) {
          var _getComputedStyle3 = getComputedStyle(element),
              height = _getComputedStyle3.height;

          element.style.height = height; // eslint-disable-next-line no-unused-expressions

          getComputedStyle(element).height;
          setTimeout(function () {
            element.style.height = 0;
          });
        }
      }
    };
    return createElement('transition', data, context.children);
  }
};